/**
 * FLAG CONSTANTS
 *
 * Mapping of constant name to string flag name, for the purpose of IDE autocompletion
 *
 * When to use:
 *    If you are using the flag in a Dojo-specific context. A good litmus test is whether
 *    you will use this within the /web/js/mojo directory. If not, there's a good chance
 *    that you don't need to add your flag name here.
 *
 * Risks:
 *    These strings get sent in cleartext to the browser in an easily-discoverable format.
 *    Many flag names have team and feature names which can be sensitive information. Only
 *    add flag names you know you'll need.
 */
define([], function () {
  var keys = {
    GEN_BRAND_ENGINE_IN_NUNI: "gen.brand_engine_in_nuni",
    FLP_LEGACY_ADVANCED_FORMS_UPDATE_PROFILE: "flp.legacy_advanced_forms_update_profile",
    FLP_EMAILLESS_CONTACTS: "flp.emailless_contacts",
    NEAPOLITAN_ONCHANGE_STYLE_INPUT: "neapolitan_onchange_style_input",
    LANDING_PAGES_BETA_BRANDED_BUNDLE: "landing_pages.beta_branded_bundle",
    ND_CIRCUIT_BREAKER_DISCONNECT: "nd.circuit_breaker.disconnect",
    AM_ORGANIZE_SELECTED_CONTACTS_COUNT: "am.organize.selected_contacts_count",
    AM_ORGANIZE_CAMPAIGN_FOLDERS_PER_AUDIENCE: "am.organize.campaign_folders_per_audience",
    AORG_AGE_GATING_ENABLED: "aorg.age_gating_enabled",
    AORG_LEGACY_ALL_CONTACTS_DEPRECATION: "aorg.legacy_all_contacts_deprecation",
    RECESS_MULTILEVEL_CAMPAIGNS: "recess.multilevel_campaigns",
    CONTACT_BILLING_MODAL_DESTROY_DESCENDANTS: "contact_billing_modal_destroy_descendants",
    MONETIZATION_PAUSE_PROMO_RESURFACING_EXPERIMENT: "monetization.pause_promo_resurfacing_experiment",
    FORCE_CHATS_OFFLINE: "force_chats_offline",
    FINOPS_PLAN_CHANGE_TIER_REFACTOR: "finops.plan_change_tier_refactor",
    MCMN_NGP_WALLET_INTEGRATION: "mcmn.ngp_wallet_integration",
    REPORTING_COMBINE_CLICKS: "reporting_combine_clicks",
    CEC_SLASH_SUPPORT_LOCALE_DROPDOWN_FIX: "cec.slash_support_locale_dropdown_fix",
    PIPE_REMOVE_LOOKALIKE: "pipe.remove_lookalike",
    REPORTING_DOWNLOAD_LINK_ATTRIBUTE: "reporting.download_link_attribute",
    PX_PROMOTE_FREE_TRIALS_VARIANT: "px.promote_free_trials_variant",
    WEF_LEFT_NAV_V2: "wef.left_nav_v2",
    NUA_INTEGRATION_DISCOVERY_EXPERIENCE: "nua.integration_discovery_experience",
    PARTNERSHIPS_WIX_IDX_PAINTEDDOOR: "partnerships.wix_idx_painteddoor",
    MVPS_CANVA_PCD_PAGE: "mvps.canva_pcd_page",
    MVPS_CANVA_IDX_CONTENT_STUDIO_PUSHER_LAZY_LOAD: "mvps.canva_idx_content_studio_pusher_lazy_load",
    MVPS_CANVA_IDX_INTEGRATION: "mvps.canva_idx_integration",
    MVPS_CANVA_IDX_NEA_PUSHER_FIX: "mvps.canva_idx_nea_pusher_fix",
    PARTNERSHIPS_WIX_IDX_PAINTEDDOOR_OVERRIDE: "partnerships.wix_idx_painteddoor_override",
    PLUMS_WIX_IDX_INTEGRATION: "plums.wix_idx_integration",
    WEF_SMARTICLES_VARIABLE_GROUP: "wef.smarticles_variable_group",
    WEF_CONTACT_RESULTS_ALL_STATUSES: "wef.contact_results_all_statuses",
    PARTNERPAGE_ECOGROWTH: "partnerpage.ecogrowth",
    APP_GOOGLE_ANALYTICS_4_SIGNUP: "app.google_analytics_4_signup",
    PARTNERPAGE_INTEGRATION: "partnerpage.integration",
    I18N_AUDIENCE_MANAGEMENT: "i18n.audience_management",
    I18N_ACCOUNT_MANAGEMENT_M2: "i18n.account_management_m2",
    I18N_PX_IN_APP: "i18n.px_in_app",
    I18N_NUNI: "i18n.nuni",
    I18N_LANDING_PAGES: "i18n.landing_pages",
    I18N_BILLING: "i18n.billing",
    I18N_REPORTING_TRANSLATIONS: "i18n.reporting_translations",
    I18N_REPORTING_TRANSLATIONS_V2: "i18n.reporting_translations_v2",
    I18N_CONTENT_OPTIMIZER: "i18n.content_optimizer",
    I18N_FORMS_FORM_BUILDER: "i18n.forms_form_builder",
    I18N_FORMS_EMBEDDED_FORMS: "i18n.forms_embedded_forms",
    I18N_FORMS_POP_UP: "i18n.forms_pop_up",
    I18N_FORMS_INTEGRATIONS: "i18n.forms_integrations",
    I18N_TRX_EMAILS: "i18n.trx_emails",
    I18N_TRX_EMAILS_VISITOR: "i18n.trx_emails_visitor",
    I18N_TRX_EMAILS_RANDOM: "i18n.trx_emails_random",
    I18N_DATE_JOURNEYS: "i18n.date.journeys",
    I18N_DATE_CAMPAIGNS: "i18n.date.campaigns",
    I18N_DATE_REPORTS: "i18n.date.reports",
    I18N_IHOP_WEEK_1: "i18n.ihop.week_1",
    I18N_IHOP_WEEK_4: "i18n.ihop.week_4",
    I18N_LOGIN_INVITATION_EMAIL: "i18n.login_invitation_email",
    WEF_REWORK_CAMPAIGNS_SEARCH_BOX: "wef.rework_campaigns_search_box",
    PIE_DISCONNECT_REDIRECT: "pie.disconnect_redirect",
    PIE_RECOMMENDATIONS_CHECKLIST_V2: "pie.recommendations_checklist_v2",
    PIE_UPDATE_SHOPIFY_BUTTON: "pie.update_shopify_button",
    I18N_AUDIENCE_MANAGEMENT_V2: "i18n.audience_management_v2",
    SMS_CAMPAIGN_SETUP: "sms.campaign_setup",
    SMS_ACTIVATE_MCADMIN_SMS_UPDATES: "sms.activate_mcadmin_sms_updates",
    SEGMENTATION_LEGACY_BUILDER_I18N: "segmentation.legacy_builder_i18n",
    SMS_DEMO_EDITOR: "sms.demo_editor",
    SMS_SUBSCRIPTION_SERVICE: "sms.subscription_service",
    HOP_UNDEFINED_MESSAGE_CONTENT_MANAGER: "hop.undefined_message_content_manager",
    CUSTOMER_JOURNEY_ACCESS_POINTS: "customer_journey_access_points",
    EEE3_REBRAND_TWITTER_X_SOCIAL_POST: "eee3.rebrand_twitter_x_social_post",
    WAYFI_SEARCH_ECS_TRACKING: "wayfi.search_ecs_tracking",
    PIE_WIX_ALERT: "pie.wix_alert",
    SEGMENTATION_ESCAPED_TAGS_LEGACY_ADVANCED_BUILDER_FIX: "segmentation.escaped_tags_legacy_advanced_builder_fix",
    ELC_RELEASE_1_SMS_COHORT: "has_elc_release_1_sms_cohort_ff",
    FINOPS_USE_LE_MIDS_FOR_AMEX: "finops.use_le_mids_for_amex",
    FINOPS_ALLOW_NEGATIVE_CREDITS: "finops.allow_negative_credits",
    ECP_BIG_CARTEL_MVP: "ecp.big_cartel_mvp",
    ECP_SHOW_DANGLING_API_KEYS: "ecp.show_dangling_api_keys",
    ECP_BYPASS_CONNECTED_SITE_REDIRECT: "ecp.bypass_connected_site_redirect",
    EEE_UPDATE_SOCIALS_ICONS: "eee.update_socials_icons",
    EEE_NEA_GENERATE_TEXT_CTA_UI_BUGFIX: "eee.nea_generate_text_cta_ui_bugfix",
    EEE_NEW_NEA_SOCIALS_FOLLOW: "eee.new_nea_socials_follow",
    EMAILIN_FIX_INBOX_PREVIEW_CLIENTS_LINK: "emailin.fix_inbox_preview_clients_link",
    ECP_KLAVIYO_INTEGRATION: "ecp.klaviyo_integration",
    I18N_DATE_ACCOUNT_SETTINGS: "i18n.date.account_settings",
    SMS_PREVENT_EDIT_TERMS: "sms.prevent_edit_terms",
    EM2_UPDATE_CONTENT_GET_INFO_RATE_LIMITING: "em2.update_content_get_info_rate_limiting",
    MVPS_NEA_CANVA_BANNER: "mvps.nea_canva_banner",
    MVPS_CANVA_MYFILES_TAB: "mvps.canva_myfiles_tab",
    YOUTUBE_REQUEST_IMPROVEMENTS: "youtube_request_improvements",
    EM2_NEA_COMMENTS_ECS_TRACKING: "em2.nea_comments_ecs_tracking",
    EM2_NEA_TO_NUNI_AWARENESS_EXPERIMENT: "em2.nea_to_nuni_awareness_experiment",
    PULSE_SUNSET_POSTCARDS_REPORTS: "pulse.sunset_postcards_reports",
    M10N_ADMIN_AGENTS_TO_ADD_MORE_THAN_ONE_DISCOUNT: "m10n.admin_agents_to_add_more_than_one_discount",
    MVPS_DISABLE_TWITTER: "mvps.disable_twitter",
    FINOPS_USER_CAN_NOT_SAVE_PAYMENT_METHOD: "finops.user_can_not_save_payment_method",
    FINOPS_GED_PAY_BY_LINK: "finops.ged_pay_by_link",
    IDENTITY_GOOGLE_SSO_EXPERIMENT: "identity.google_sso_experiment",
    REPORTING_INDIVIDUAL_EMAIL_REPORT_REACT_MIGRATION: "reporting.individual_email_report_react_migration",
    IDENTITY_MC_GSSO_LOGIN_FLOW_DOTCOM_INTEGRATION: "identity.mc_gsso_login_flow_dotcom_integration",
    XP_ADD_INTL_PROVIDER_REAUTH: "xp.add_intl_provider_reauth",
    REPORTING_MIGRATE_RECIPIENT_ACTIVITY: "reporting.migrate_recipient_activity",
    MCIP_UPDATE_DISCOVER_URL_IN_SEGMENTS: "mcip.update_discover_url_in_segments",
    HA_ENABLE_DEMO_ACCT_FOR_PARTNER_TIER: "ha.enable_demo_acct_for_partner_tier",
    HA_BYPASS_DEMO_ACCOUNT_CREATION_LIMIT_CHECK: "ha.bypass_demo_account_creation_limit_check",
    HA_FIX_STALE_MC_RIGHT_RAIL_OPEN: "ha.fix_stale_mc_right_rail_open",
    HA_DOJO_CHAT_POP_OUT_FIX: "ha.dojo_chat_pop_out_fix",
    MCIP_TWITTER_INTEGRATION_DISCONNECT_BUTTON_SHOW: "mcip.twitter_integration_disconnect_button_show",
    MCMN_MSE_SUBSCRIPTION_MAILCHIMP_THEME: "mcmn.mse_subscription_mailchimp_theme",
    REPORTING_VIPSHARE_SHOW_PASSWORD_LOADING: "reporting.vipshare_show_password_loading",
    EEE_CANVA_CYO: "eee.canva_cyo",
    REPORTING_COMPARATIVE_REPORTS_CSRF_PROTECTION: "reporting.comparative_reports_csrf_protection",
    REPORTING_EMAIL_REPORTS_ECOMMERCE_MIGRATION_TO_REACT: "reporting.email_reports_ecommerce_migration_to_react",
    CC_X632_ACP_PERSIST_SELECTION_ON_RETURN: "cc.x632_acp_persist_selection_on_return"
  };
  return keys;
});